import ReportAPI from './report.api'

export default ReportAPI